import { SearchX } from "lucide-react";

export function EmptyState({ filtered }: { filtered: boolean }) {
  return <div className="empty-state">
    <span><SearchX size={24} /></span>
    <strong>{filtered ? "По этим условиям ничего не найдено" : "В sales-базе пока нет объявлений"}</strong>
    <p>{filtered ? "Измените запрос или сбросьте фильтры." : "Интерфейс покажет строки после обновления results.sqlite."}</p>
  </div>;
}
